import React from 'react';
import Reveal from './Reveal';
import './Services.css';

const SERVICES = [
  {
    img: '/assets/bikesdrop/pickup_delivery.jpg',
    title: 'Pickup & Delivery',
    tag: 'Point to point',
    text: 'Send a document, a parcel or a gift across town. A verified rider picks it up and delivers it, tracked live from start to finish.',
  },
  {
    img: '/assets/bikesdrop/campus_errands.jpg',
    title: 'BikesFood & BikesGroceries',
    tag: 'Restaurants, market vendors & shops',
    text: 'Order a meal through BikesFood or fresh produce and pantry staples through BikesGroceries. Browse local restaurants, market women and shops, add to cart, and a rider brings it straight to you.',
  },
  {
    img: '/assets/bikesdrop/cargo_delivery.jpg',
    title: 'Cargo Delivery',
    tag: 'Big moves, real trucks',
    text: 'Moving house or restocking a store? Book a real truck with trained handlers for furniture, appliances and bulk loads, door to door.',
  },
  {
    img: '/assets/bikesdrop/Okada.jpg',
    title: 'Okada',
    tag: 'Beat the traffic',
    text: 'Hop on the back of a verified rider’s motorbike and get across town fast, weaving past the traffic that slows a car down.',
  },
  {
    img: '/assets/bikesdrop/pickup_delivery.jpg',
    title: 'Campus & Community Errands',
    tag: 'Local errands, fast',
    text: 'Grocery runs, gas cylinder refills, printing and everyday campus tasks, handled by riders who know your campus and community.',
  },
  {
    img: '/assets/bikesdrop/schedule_delivery.jpg',
    title: 'Schedule Delivery',
    tag: 'Your time, your choice',
    text: 'Plan ahead. Choose the date and time slot that works for you, and a rider will be ready to deliver exactly when you need it.',
  },
];

export default function Services() {
  return (
    <section className="services section" id="services">
      <div className="container">
        <Reveal className="services__head">
          <span className="eyebrow eyebrow--teal">What We Offer</span>
          <h2 className="section-heading">Eight services, one app, endless convenience</h2>
          <p className="section-sub">
            Whatever needs to move across your city or campus, BikesDrop has a service built for it,
            handled by verified riders and trusted partners.
          </p>
        </Reveal>

        <div className="services__grid">
          {SERVICES.map((s, i) => (
            <Reveal delay={(i % 3) * 70} className="service-card" key={s.title}>
              <div className="service-card__media">
                <img src={s.img} alt={s.title} />
              </div>
              <div className="service-card__tag-row">
                <span className="service-card__tag">{s.tag}</span>
                {s.comingSoon && <span className="coming-soon">Coming soon</span>}
              </div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
